<template>
<div>
  <b-card v-if="working" class="text-center">
    <div v-if="job_status && job_status.id">{{ job_status.description }}</div>
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </b-card>
  <div v-if="!working">

    <b-card no-body>
      <b-tabs card>
        <b-tab title="Lista">
          <div class="text-right mb-3">
            <router-link class="btn btn-primary" :to="{name:'fees.create'}"><i class="fa fa-plus"></i> Criar</router-link>
            <b-button class="btn btn-primary" @click="exportGrid()" ><i class="fa fa-download"></i> Exportar</b-button>
          </div>
          <Grid ref="feesGrid" name="feesGridv2" :editable="false" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
        </b-tab>
        <b-tab title="Operações">
          <b-button class="btn btn-primary" @click="showModal()" >Criar quotas</b-button>
          <b-button class="btn btn-primary" @click="showModal2()" >Gerar referências</b-button>
          <b-button class="btn btn-primary" @click="showModal3(1)" >Email Pagamento Quotas</b-button>
          <b-button class="btn btn-primary" @click="showModal3(2)" >Enviar lembrete de quotas</b-button>
          <b-table striped :fields="jobs_fields" :items="jobs_list">
            <template v-slot:cell(state)="data">
              {{ states.translate(data.value, 'jobs') }}
            </template>
            <template #cell(show_details)="row">
              <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
              </b-button>
            </template>
            <template #cell(count_emails)="row">
              {{ row.item.emails.data.length }}
            </template>

            <template #row-details="row">
              <operation :items="row.item.emails.data"></operation>
            </template>

          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>


  </div>
  <b-modal id="create-fees" hide-footer>
    <template v-slot:modal-title>
      Criar quotas anuais
    </template>
    <div class="d-block ">
      <p>Criar quota para o ano</p>
      <b-form-fieldset  label="Ano para gerar as quotas">
        <b-form-input type="number" step="1" name="year" v-model="creator.year" placeholder="Ano" v-validate="{ required: true }" ></b-form-input>
        <b-form-invalid-feedback>
          {{ errors.first('year') }}
        </b-form-invalid-feedback>
      </b-form-fieldset>
      <b-form-fieldset label="ID Família (opcional)">
        <b-form-input type="number" step="1" name="family_id" v-model="creator.family_id" placeholder="ID Família" v-validate="{ required: false }" ></b-form-input>
        <b-form-invalid-feedback>
          {{ errors.first('family_id') }}
        </b-form-invalid-feedback>
      </b-form-fieldset>

          <b-form-fieldset  label="Gerar referências Multibanco para as quotas criadas?">
            <b-form-select v-model="creator.generateMB" class="mb-3" name="state"  :options="states.yesNo" >
            </b-form-select>
          </b-form-fieldset>

    </div>
    <b-button class="mt-3" @click="$bvModal.hide('create-fees')">Cancelar</b-button>
    <b-button variant="success" class="mt-3 pull-right" @click="createFees()">Continuar</b-button>
  </b-modal>
  <b-modal id="create-mb" hide-footer>
    <template v-slot:modal-title>
      Criar referências MB
    </template>
    <div class="d-block ">
      <p>Criar referências para o ano</p>
      <b-form-fieldset label="Ano">
        <b-form-input type="number" step="1" name="year" v-model="creator.year" placeholder="Ano" v-validate="{ required: true }" ></b-form-input>
        <b-form-invalid-feedback>
          {{ errors.first('year') }}
        </b-form-invalid-feedback>
      </b-form-fieldset>
      <b-form-fieldset label="ID Família (opcional)">
        <b-form-input type="number" step="1" name="family_id" v-model="creator.family_id" placeholder="ID Família" v-validate="{ required: false }" ></b-form-input>
        <b-form-invalid-feedback>
          {{ errors.first('family_id') }}
        </b-form-invalid-feedback>
      </b-form-fieldset>
    </div>
    <b-button class="mt-3" @click="$bvModal.hide('create-mb')">Cancelar</b-button>
    <b-button variant="success" class="mt-3 pull-right" @click="createRefs()">Continuar</b-button>
  </b-modal>
  <b-modal id="send-emails" hide-footer>
    <template v-slot:modal-title>
      Enviar emails para pagamento
    </template>
    <div class="d-block ">
      <b-form-input type="number" step="1" name="family_id" v-model="creator.family_id" placeholder="ID Família" v-validate="{ required: true }" ></b-form-input>
    </div>
    <b-button class="mt-3" @click="$bvModal.hide('send-emails')">Cancelar</b-button>
    <b-button variant="success" class="mt-3 pull-right" @click="sendEmails()">Enviar</b-button>
  </b-modal>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import States from '@/components/Lists.js'
import Operation from './operations.vue'
export default {
  name: 'ActivitiesGrid',
  components: {
    Grid, Operation
  },
  data() {
    return {
      exporting: false,
      fileDownload: {
        url: '',
        title: ''
      },
      working: false,
      states: States,
      job_status: {
        id: null,
        name: null,
        description: null,
        state: null,
      },
      email_type: null,
      jobs_list: [],
      creator: {
        year: 2021,
        generateMB: 1,
        cancelExisting: 0,
        family_id: null
      },
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'paid_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        },
        state: {
          type: 'number',
          editable: true
        },
        fee_year: {
          type: 'number',
          editable: false
        },
        fee_value: {
          type: 'number',
          editable: false
        },
        family_id: {
          type: 'number',
          editable: false
        }
      },

      url: 'fees',
      preload: [],
      columns: [{
          template: this.getBtnTemplate,
          title: '',
          width: '120px'
        }, {
          field: 'family_id',
          title: 'ID Família',
          width: '180px'
        },
        {
          field: 'state',
          title: 'Estado',
          width: '180px',
          values: States.feeStates
        },
        {
          field: 'fee_year',
          title: 'Ano',
          width: '180px'
        },
        {
          field: 'fee_value',
          title: 'Valor',
          width: '180px'
        },
        {
          field: 'reference_entity',
          title: 'Entidade',
          width: '180px'
        },
        {
          field: 'reference_reference',
          title: 'Referência',
          width: '180px'
        },
        {
          field: 'paid_value',
          title: 'Valor pago',
          width: '180px'
        },
        {
          field: 'paid_at',
          title: 'Dt. Pagamento',
          format: '{0:dd/MM/yyyy HH:mm}',
          width: '180px'
        },
        {
          field: 'created_at',
          title: 'Criado em',
          format: '{0:dd/MM/yyyy HH:mm}',
          type: 'date',
          width: '180px',
          filterable: {
            // ui: "datetimepicker"
            ui: function(element) {
              element.kendoDateTimePicker({
                format: 'dd/MM/yyyy HH:mm'
              })
            }
          }
        }, {
          field: 'id',
          title: 'Id',
          width: '80px',
          editable: false
      }],
      jobs_fields: [{
        key: 'description',
        text: 'Descrição'
      }, {
        key: 'state',
        text: 'Estado'
      }, {
        key: 'count_emails',
        text: 'Emails'
      }, {
        key: 'updated_at',
        value: 'Última atualização'
      }, {
        key: 'show_details',
        text: ''
      }]
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.feesGrid.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post('fees/export', {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
    createFees() {
      this.$bvModal.hide('create-fees')
      this.working = true
      this.doCreateFees(0)
    },
    doCreateFees(skip) {
      this.axios.post('fees/batch', this.creator).then(response => {
        // console.log(response)
        this.job_status = response.data.job
        this.checkProgress(response.data.job.id)
        // if(response.data.data.created > 0) {
        //   skip = skip + response.data.data.created
        //   this.doCreateFees(skip)
        // } else {

        //   // this.$bvToast.toast('foram criados ' + skip + ' quotas', { autoHideDelay: 5000, variant: 'success', solid: true})
        // }
      })
    },
    getJobs() {
      this.axios.get('jobs/all/fees').then(response => {
        this.jobs_list = response.data.data
      })
    },
    checkProgress(job_id) {
      let job = job_id || null
      let job_url = 'jobs/status/fees'
      if(job) {
        job_url += '/' + job
      }
      var that = this
      this.axios.get(job_url).then(response => {
        this.job_status = response.data.data
        if(this.job_status == null) {
          return;
        }
        if( this.job_status.state == 0 || this.job_status.state == 1) {
          that.working = true
          setTimeout(function() {
            that.checkProgress(that.job_status.id)
          }, 3 * 1000)
        } else {
          that.working = false
          that.getJobs()
        }
      })
    },
    createRefs() {
      this.$bvModal.hide('create-mb')
      this.working = true
      this.doCreateRefs(0)
    },
    doCreateRefs(skip) {
      let data = this.creator
      data.skip = skip
      this.axios.post('fees/references', data).then(response => {
        this.job_status = response.data.job
        this.checkProgress(response.data.job.id)
      })
    },
    sendEmails() {
      let data = {}
      data.email_type = this.email_type
      data.family_id = this.creator.family_id
      this.$bvModal.hide('send-emails')
      this.working = true
      this.axios.post('fees/emails', data).then(response => {
        this.working = false
        this.getJobs()
      })
    },
    showModal() {
      this.$bvModal.show('create-fees')
    },
    showModal2() {
      this.$bvModal.show('create-mb')
    },
    showModal3(email_type) {
      this.email_type = email_type
      this.$bvModal.show('send-emails')
    },
    getBtnTemplate: function(item) {
      if (this.$auth.check('fees.edit')) {
        var route = router.resolve({
          name: 'fees.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('fees.view')) {
        var route = router.resolve({
          name: 'fees.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    },
  },
  created() {
    this.checkProgress()
    this.getJobs()
  }
}
</script>
